import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

import { EXO_SKELETON_EVENT_NAMES } from '@adsk/exo-skeleton-api/internal';

import { EXO_SKELETON_PLACEHOLDER } from '../const';

function waitForExoRemotesListToLoad() {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(
        new Error(
          '[ ExoSkeletonRuntimePlugin: "setRemoteUrlFromPlaceholder" ] Timed out waiting for remotes list to load',
        ),
      );
    }, 5000);

    // Listen for the remotes list event
    window.addEventListener(
      EXO_SKELETON_EVENT_NAMES.REMOTES_LIST_FETCHED,
      () => {
        clearTimeout(timeoutId);
        resolve(null);
      },
      { once: true },
    );
  });
}

const runtimePlugin: () => ModuleFederationRuntimePlugin = () => {
  return {
    name: 'setRemoteUrlFromPlaceholder',
    beforeRequest: async (
      args: Parameters<
        NonNullable<ModuleFederationRuntimePlugin['beforeRequest']>
      >[0],
    ) => {
      if (!window.ExoSkeletonRuntime) {
        await waitForExoRemotesListToLoad();
      }

      for (const remote of args.options.remotes) {
        const remoteDetails = window.ExoSkeletonRuntime!.remotes![remote.name];

        if (
          remoteDetails &&
          (remote as typeof remote & { entry: string })?.entry.includes(
            EXO_SKELETON_PLACEHOLDER,
          )
        ) {
          (remote as typeof remote & { entry: string }).entry =
            remoteDetails.url;
        }
      }

      return args;
    },
  };
};

export default runtimePlugin;
